import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";

export default function ManualContactSafety({
  whatsappId,
  contactId,
  ticketId,
  creation = false,
  onChange,
}) {
  const scope = JSON.stringify([whatsappId, contactId, ticketId]);
  const [result, setState] = useState(null);
  const state = result?.scope === scope ? result : null;
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setState(null);
    setChecked(false);
    setError(false);
    if (!ticketId && (!whatsappId || !contactId)) return;
    const load = async () => {
      try {
        const { data } = await api.get(
          "/whatsapp-protection/manual/preflight",
          { params: ticketId ? { ticketId } : { whatsappId, contactId } }
        );
        if (!cancelled) {
          setState({ ...data, scope });
          setError(false);
        }
      } catch (_) {
        if (!cancelled) {
          setError(true);
          setState(null);
        }
      }
    };
    load();
    const timer = setInterval(load, 15000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [whatsappId, contactId, ticketId, scope, refresh]);
  useEffect(() => {
    onChange?.({
      whatsappId,
      contactId,
      ready: Boolean(state),
      blocked: error || Boolean(state?.blocked),
      contactAuthorized: Boolean(state && (state.authorized || checked)),
      requiresAuthorization: Boolean(state?.requiresAuthorization),
    });
  }, [state, checked, error, onChange, whatsappId, contactId]);
  const authorize = async () => {
    setBusy(true);
    try {
      await api.post("/whatsapp-protection/manual/authorize", {
        ...(ticketId ? { ticketId } : { whatsappId, contactId }),
        contactAuthorized: true,
      });
      setRefresh((value) => value + 1);
    } catch (err) {
      toastError(err);
    } finally {
      setBusy(false);
    }
  };
  if (!ticketId && (!whatsappId || !contactId)) return null;
  if (state?.applies === false) return null;
  return (
    <Box
      role="status"
      p={1.5}
      mt={1}
      mb={1}
      style={{
        border: `1px solid ${error || state?.blocked ? "#c62828" : "#cbd5e1"}`,
        borderRadius: 6,
      }}
    >
      <Typography variant="body2">
        <strong>Proteção do contato manual</strong>
      </Typography>
      {!state && !error && (
        <Typography variant="caption">Verificando a conexão…</Typography>
      )}
      {error && (
        <>
          <Typography color="error" variant="body2">
            Não foi possível verificar a proteção. Tente novamente antes de
            enviar.
          </Typography>
          <Button size="small" onClick={() => setRefresh((value) => value + 1)}>
            Tentar novamente
          </Button>
        </>
      )}
      {state?.blocked && (
        <Typography role="alert" variant="body2" color="error">
          {state.message}
        </Typography>
      )}
      {state?.mode === "REPLY" && !state.blocked && (
        <Typography variant="caption">
          Conversa ativa: respostas protegidas contra rajadas e repetições.
        </Typography>
      )}
      {state?.mode === "OUTREACH" && (
        <Typography variant="caption" display="block">
          Abordagem sem resposta recente · {state.newContactsToday} de{" "}
          {state.dailyNewContactLimit} contatos novos hoje. As pausas e os
          limites desta conexão também se aplicam aqui.
        </Typography>
      )}
      {state?.requiresAuthorization && !state.blocked && (
        <>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                disabled={busy}
                onChange={(event) => setChecked(event.target.checked)}
              />
            }
            label="Confirmo que tenho autorização para contatar esta pessoa pelo WhatsApp."
          />
          {!creation && (
            <Button
              size="small"
              color="primary"
              disabled={!checked || busy}
              onClick={authorize}
            >
              {busy ? "Registrando…" : "Confirmar autorização"}
            </Button>
          )}
        </>
      )}
    </Box>
  );
}
